import { render, staticRenderFns } from "./regRecordUpload.vue?vue&type=template&id=d3d97630"
import script from "./regRecordUpload.vue?vue&type=script&lang=js"
export * from "./regRecordUpload.vue?vue&type=script&lang=js"
import style0 from "./regRecordUpload.vue?vue&type=style&index=0&id=d3d97630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports